module.exports = __webpack_public_path__ + "img/scenes.7e8c9895.png";